import React, { useState } from "react";

/**
 * InviteButton — one-tap share for friends & family.
 *  - On phones/tablets that support navigator.share, opens the native share sheet
 *    (WhatsApp, iMessage, Telegram, email, etc.)
 *  - On desktop & older browsers, falls back to copy-to-clipboard + a quick toast
 *  - Tracks ?invite_from=<handle> so we can later count viral installs per Sciencer
 */
const INVITE_URL = "https://seanthesciencekidofficial.com/";

const PRESET_MESSAGES = [
  "🧡 Yo! Sean The Science Kid built this Reading + AI lab — race me on it!",
  "⚡ Just installed Sean's Lab. He talks back! Try it →",
  "🦎 Sean has an AI now and it's hilarious. Install it before me:",
];

export default function InviteButton({ variant = "inline", handle }) {
  const [toast, setToast] = useState("");

  const buildUrl = () => {
    try {
      const u = new URL(INVITE_URL);
      if (handle) u.searchParams.set("invite_from", handle);
      return u.toString();
    } catch {
      return INVITE_URL;
    }
  };

  const onShare = async () => {
    const url = buildUrl();
    const text = PRESET_MESSAGES[Math.floor(Math.random() * PRESET_MESSAGES.length)];
    const shareData = {
      title: "Sean The Science Kid",
      text,
      url,
    };

    // 1) Try native share first
    if (typeof navigator.share === "function") {
      try {
        await navigator.share(shareData);
        return;
      } catch (e) {
        // User canceled OR share threw. If it was a real failure, fall through to copy.
        if (e?.name === "AbortError") return;
      }
    }

    // 2) Fallback: copy link
    try {
      await navigator.clipboard.writeText(`${text} ${url}`);
      setToast("📋 Invite link copied!");
    } catch {
      // 3) Last-resort fallback: prompt
      window.prompt("Copy this invite link:", `${text} ${url}`);
      return;
    }
    setTimeout(() => setToast(""), 2400);
  };

  const isHeader = variant === "header";
  return (
    <>
      <button
        type="button"
        onClick={onShare}
        data-testid="invite-btn"
        aria-label="Invite friends to Sean's Lab"
        title="Invite friends & family"
        className={isHeader ? "btn btn-ghost text-xs sm:text-sm" : "btn"}
        style={isHeader
          ? { padding: "0.4rem 0.7rem", background: "#fff", borderColor: "var(--ink)" }
          : { background: "var(--orange)", color: "#fff" }}
      >
        <span className="sm:hidden" aria-hidden>📲</span>
        <span className="hidden sm:inline">📲 Invite friends</span>
      </button>

      {toast && (
        <div
          className="fixed z-[70] no-print"
          data-testid="invite-toast"
          style={{
            top: 14,
            left: "50%",
            transform: "translateX(-50%)",
            padding: "0.6rem 1.1rem",
            background: "var(--ink)",
            color: "#fff",
            borderRadius: 999,
            fontSize: "0.85rem",
            fontWeight: 700,
            boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
          }}
        >
          {toast}
        </div>
      )}
    </>
  );
}
